import React from 'react';

import { useTopLevelDetailsSectionQuery } from 'generated/graphql';
import _ from 'lodash';
import {
  formatUtil,
  useLoading
} from 'modules';



export function useTopLevelDetailsSection() {
  const tuple = useTopLevelDetailsSectionQuery({});
  const loading = useLoading([tuple]);

  return React.useMemo(() => {
    const loggedInUser = tuple.data?.loggedInUser;
    const companyProfile = loggedInUser?.companyProfile;
    const investorProfile = loggedInUser?.investorProfile;
    return {
      loading,
      data: {
        profilePictureKey: companyProfile?.logo?.key ?? '',
        fullName: `${loggedInUser?.firstName ?? ''} ${loggedInUser?.lastName ?? ''}`,
        address: companyProfile?.address ? `${companyProfile?.address.city}, ${companyProfile?.address.usState}, ${companyProfile?.address.country}` : '',
        companyName: companyProfile?.name ?? '',
        websiteUrl: companyProfile?.websiteUrl ?? '',
        email: loggedInUser?.email ?? '',
        phoneNumber: companyProfile?.phoneNumber ?? '',
        description: companyProfile?.description ?? '',
        logoKey: companyProfile?.logo?.key ?? '',

        investmentStages: _.map(companyProfile?.investmentStages?? [], stage => stage.displayName),
        investmentAreas: _.map(companyProfile?.investmentAreas ?? [], area => area.displayName),
        investmentGeographies: _.map(companyProfile?.investmentGeographies ?? [], geo => geo.displayName),

        checkSizeMinDollars: formatUtil.getDollarString(investorProfile?.checkSizeMinDollars),
        checkSizeMaxDollars: formatUtil.getDollarString(investorProfile?.checkSizeMaxDollars)
      }
    };
  }, [tuple, loading]);
}
